/** Fired after SA/Admin approve/reject so menu + dashboard pending badges refresh. */
export const SA_PENDING_APPROVALS_CHANGED = 'saPendingApprovalsChanged';

export function notifySaPendingApprovalsChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SA_PENDING_APPROVALS_CHANGED));
}
